import { render } from "./MultipleColumnsFrom.vue?vue&type=template&id=47163823"
import script from "./MultipleColumnsFrom.vue?vue&type=script&lang=ts"
export * from "./MultipleColumnsFrom.vue?vue&type=script&lang=ts"

import "./MultipleColumnsFrom.vue?vue&type=style&index=0&id=47163823&lang=scss"
script.render = render

export default script